module.exports = __webpack_public_path__ + "img/27.0a29ca91.png";